// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const v1ExternalLinkSchema = z.object({
  provider_type: z.coerce.string(),
  provider_id: z.coerce.string(),
  external_id: z.coerce.string(),
  uri: z.coerce.string().nullish(),
  data: z.optional(z.object({})),
});
